import { render, staticRenderFns } from "./UcContractRentalCard.yaml?vue&type=template&id=0d5f8057&component"
import script from "./UcContractRentalCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractRentalCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports